import {uiMsg} from '../utils/Languages';
import React, {Component} from 'react';
import { Link } from 'react-router';
import {observer} from 'mobx-react';

import Paper from 'material-ui/Paper';
import CircularProgress from 'material-ui/CircularProgress';
import TextField from 'material-ui/TextField';
import {List, ListItem} from 'material-ui/List';
import Subheader from 'material-ui/Subheader';
import RaisedButton from 'material-ui/RaisedButton';
import FlatButton from 'material-ui/FlatButton';

import {Toolbar, ToolbarGroup, ToolbarSeparator, ToolbarTitle} from 'material-ui/Toolbar';
import Dialog from 'material-ui/Dialog';
import Checkbox from 'material-ui/Checkbox';

import AppModel from '../DataModel/AppModel';
import AppModelUtils from '../DataModel/AppModelUtils';
import PageLoading from '../components/PageLoading';
import SelectParentLocation from '../components/SelectParentLocation';
import SelectDefaultJobType from '../components/SelectDefaultJobType';
import RegisterBeacon from '../components/RegisterBeacon';
import MachineList from '../components/MachineList';
import {Table, TableBody, TableHeader, TableHeaderColumn, TableRow, TableRowColumn} from 'material-ui/Table';

import * as TimeFormatter from '../utils/TimeFormatter';


const formStyle = {
  marginLeft: 24
};

export default
@observer class EditRoomPage extends Component {

  static contextTypes = {
    router: React.PropTypes.object
  }

  // Helper method that writes values back to datamodel as fields are changed
  handleValue(event) {
    console.log("handleValue called");
    var field = event.target.dataset.propname;
    var value = event.target.value;
    if(value=="") value = null;
    AppModel.updateRoomForm.location[field]=value;
  }

  toggleDeleted(event) {
    console.log("Toggeling deleted flag");
    AppModel.updateRoomForm.location.deleted=!AppModel.updateRoomForm.location.deleted;
  }

  updateOrDeleteRoom() {
    AppModelUtils.updateOrDeleteLocation()
    .then(()=> {
        AppModel.updateRoomForm.reset();
        this.context.router.goBack();
    })
    .catch(()=> {
        console.log("Update was rejected, staying on page");
    });
  }

  duplicateRoom(){
    AppModel.newRoomForm = AppModel.updateRoomForm;
    this.context.router.push("/rooms/duplicateRoom");
  }

  cancelUpdate() {
    AppModel.updateRoomForm.reset();
    this.context.router.goBack();
  }

  resetUpdateOperation() {
    // When server op failed and dialog box with error has been shown.
    AppModel.updateRoomForm.serverOperation.reset();
  }

  cannotEditLocation() {
    const no_action = [
      <FlatButton
        label={uiMsg('OK',"OK")}
        primary={true}
        onTouchTap={this.cancelUpdate.bind(this)} />,
    ];
    var message =" You do not have permission to modify locations. "+
    " Talk to your local area or system administrator to have permissions "+
    " changed.";
    return <Dialog
      title={uiMsg('ER_INSUFFICIENT_PERM',"Insufficient permissions")}
      actions={no_action}
      modal={true}
      open={true}>
      {message}
    </Dialog>
  }

  readOnlyLocationPage(location) {
    let headerStyle = {
      fontFamily: "Roboto, sans-serif",
      fontSize: "20px",
      fontWeight: "400",
      height: "48px",
      lineHeight: "48px"
    }
    let pageStyle = {
      margin:"1em",
    };

    // Lookup the type of the location to display readable name :
    let location_type = appState.locationTypes.find(lt => lt.id==location.id_type);
    // If we found the location type definition, use name from it, if not just show id:
    location_type = location_type ? location_type.name : location.id_type;
    // Look up name of parent location
    let parentLoc = appState.parentLocationChoices.find( pl => pl.id == location.id_parent);
    parentLoc = parentLoc ? parentLoc.name : null;
    // Look up name of default job type for location:
    let jobType = appState.availableJobTypes.find( jt => jt.id == location.default_job_type);
    jobType = jobType ? jobType.name : location.default_job_type;

    let last_disinfected = location.last_disinfected ? TimeFormatter.dateAndTime(location.last_disinfected) : "-";

    // Render a readable view of location information:
    return (
      <div style={pageStyle}>
      <PageLoading loading={ AppModel.fetchingLocationData
              || AppModel.fetchingAvailableJobTypes
              || AppModel.fetchingLocationTypes
            }>

        <h2 style={headerStyle}>{uiMsg('ER_H_LOCATION_INFO',"Location information")}</h2>
        <Table>
          <TableBody displayRowCheckbox={false}>
            { parentLoc ?
            <TableRow> <TableRowColumn>{uiMsg('ER_PARENT_LOCATION',"Parent Location")}:</TableRowColumn>
              <TableRowColumn>{parentLoc}</TableRowColumn></TableRow>
            :null }
            <TableRow> <TableRowColumn>{uiMsg('ER_LOCATION_TYPE',"Location type")}:</TableRowColumn>
              <TableRowColumn>{location_type}</TableRowColumn></TableRow>
            <TableRow> <TableRowColumn>{uiMsg('ER_LOCATION_NAME',"Location name")}:</TableRowColumn>
              <TableRowColumn>{location.name}</TableRowColumn></TableRow>
            {location.id_type!='R' ? null :
              <TableRow> <TableRowColumn>{uiMsg('ER_TL_HEIGHT',"Height")}:</TableRowColumn>
                <TableRowColumn>{location.height || "-"}</TableRowColumn></TableRow>
            }
            {location.id_type!='R' ? null :
              <TableRow> <TableRowColumn>{uiMsg('ER_TL_LENGTH',"Length")}:</TableRowColumn>
                <TableRowColumn>{location.length || "-"}</TableRowColumn></TableRow>
            }
            {location.id_type!='R' ? null :
              <TableRow> <TableRowColumn>{uiMsg('ER_TL_WIDTH',"Width")}:</TableRowColumn>
                <TableRowColumn>{location.width || "-"}</TableRowColumn></TableRow>
            }
            {location.id_type!='R' ? null :
              <TableRow> <TableRowColumn>{uiMsg('ER_TL_VOLUME',"Volume")}:</TableRowColumn>
                <TableRowColumn>{location.finalVolume} m<sup>3</sup></TableRowColumn></TableRow>
            }
            {location.id_type!='R' ? null :
              <TableRow> <TableRowColumn>{uiMsg('ER_DEFAULT_JOB_TYPE',"Default job type")}:</TableRowColumn>
                <TableRowColumn>{jobType}</TableRowColumn></TableRow>
            }
            {location.id_type!='R' ? null :
              <TableRow> <TableRowColumn>{uiMsg('ER_LAST_DISINFECTED',"Last disinfected")}:</TableRowColumn>
                <TableRowColumn>{last_disinfected}</TableRowColumn></TableRow>
            }
          </TableBody>
        </Table>
      </PageLoading></div>
    );
  }

  numberParseError(num) {
    if(typeof(num)=='string') {
      num=num.replace(",",".");
    }
    if(isNaN(+num)) return uiMsg('ER_NOT_NUMBER',"Unable to parse number");
    return "";
  }

  render() {
    var form = AppModel.updateRoomForm;
    var location = form.location;
    if(!AppModel.canEditLocations) {
      return this.readOnlyLocationPage(location);
    }

    var volume_error_msg = location.volumeErrorMessage;
    var operation = form.serverOperation;
    var showFailDialog = ("FAIL"==operation.result);
    // If there are more than one job type for this customer, we will
    // allow the user to set a default job type for each location:
    var showJobTypeSelector = AppModel.availableJobTypes.length>1;
    // Action to dismiss server-error dialog if it pops up :
    const actions = [
      <FlatButton
        label={uiMsg('OK',"OK")}
        primary={true}
        onTouchTap={this.resetUpdateOperation} />,
    ];
    return (
      <PageLoading loading={operation.waiting
            || AppModel.fetchingLocationData
            || AppModel.fetchingAvailableJobTypes
            || AppModel.fetchingLocationTypes
          }>
        <Dialog
          title={uiMsg('SERVER_FAILED',"Server operation failed")}
          actions={actions}
          modal={true}
          open={showFailDialog}>
          {operation.message}
        </Dialog>
        <List>
          <Subheader>{uiMsg('ER_UPDATE_INFO',"Update information")}</Subheader>
        <div style={formStyle}>
          <SelectParentLocation target={location} />
          <TextField  data-propname="name"
                      floatingLabelText={
                        location.isNameValid?
                          uiMsg('ER_NAME_PROMPT',"Name of X",location.typeName.toLowerCase())
                        : uiMsg('ER_NAME_PROMPT_REQ',"Name of X (required)",location.typeName.toLowerCase())
                      }
                      hintText={uiMsg('ER_NAME_PROMPT_HINT',"E.g. 104, A etc.")}
                      fullWidth={true}
                      value={location.name || ""}
                      onChange={this.handleValue}
              />
           {location.id_type!='R' ? null : (<span>
              <TextField  data-propname="height"
                          floatingLabelText={uiMsg('ER_HEIGHT',"Height in m" )}
                          hintText={uiMsg('ER_HEIGHT_HINT',"Height" )}
                          data-propname="height"
                          value={location.height || ""}
                          onChange={this.handleValue}
                          fullWidth={true}
                          errorText={this.numberParseError(location.height)}
                />
              <TextField  data-propname="length"
                          floatingLabelText={uiMsg('ER_LENGTH',"Length in m")}
                          hintText={uiMsg('ER_LENGTH_HINT',"Length")}
                          data-propname="length"
                          value={location.length || ""}
                          onChange={this.handleValue}
                          errorText={this.numberParseError(location.length)}
                          fullWidth={true}
                />
              <TextField  data-propname="width"
                          floatingLabelText={uiMsg('ER_WIDTH',"Width in m")}
                          hintText={uiMsg('ER_WIDTH_HINT',"Width")}
                          data-propname="width"
                          value={location.width || ""}
                          onChange={this.handleValue}
                          fullWidth={true}
                          errorText={this.numberParseError(location.width)}
                />
              <TextField  data-propname="volume_m3"
                          floatingLabelText={
                            location.computedVolume ?
                              uiMsg('ER_COMPUTED_VOL',"Computed volume=X m^3",location.computedVolume.toFixed(2))
                            : uiMsg('ER_VOLUME_M3',"Volume in m^3")
                          }
                          hintText={uiMsg('ER_VOLUME_M3_HINT',"Volume, leave empty to use computed value")}
                          data-propname="volume_m3"
                          value={location.volume_m3 || ""}
                          onChange={this.handleValue}
                          errorText={!!volume_error_msg ?
                            volume_error_msg : null}
                          fullWidth={true}
                />
              

              {showJobTypeSelector ? <SelectDefaultJobType location={location} /> : null}

             </span>)
           }
          </div>

          {location.id_type!='R' ? null : (
            <div>
              <Subheader>Beacons</Subheader>
              <div style={formStyle}>
              
                <span>
                  <RegisterBeacon location={location} form={form} parent={this}/>
                </span>
              </div>
            </div>
            )}
        </List>

        <List><Subheader>{uiMsg('ER_H_DELETE_LOCATION',"Delete location")}</Subheader>
          <div style={formStyle}>
          <Checkbox data-propname="deleted"
                    label={location.isContainer?
                        uiMsg('ER_DELETE_AREA_AND_CONTAINED_ROOMS',"Delete this area and all rooms contained by it.")
                      : uiMsg('ER_DELETE_ROOM',"Delete this room")}
                    disabled={location.numberOfUsers > 0}
                    checked={location.deleted}
                    onCheck={this.toggleDeleted}
            />
          {location.numberOfUsers > 0 ?
            <div>{uiMsg('ER_AREA_CANNOT_BE_DELETED_HAS_USERS'
              ,"Area cannot be deleted as there are users assigned within it.")}
            </div>
          : null}
        </div>
        </List>
        <Toolbar>
          <ToolbarGroup firstChild={true}>
            <RaisedButton
              primary
              disabled = {!location.isValid}
              onTouchTap={this.duplicateRoom.bind(this)}>
              {uiMsg("ER_DUPLICATE") || "Duplicate"}
            </RaisedButton>
          </ToolbarGroup>
          <ToolbarGroup lastChild={true}>
            <FlatButton
                    onTouchTap={this.cancelUpdate.bind(this)}>
                    {uiMsg("ER_CANCEL")}
            </FlatButton>
            <RaisedButton primary
                          disabled = {!location.isValid}
                          onTouchTap={this.updateOrDeleteRoom.bind(this)}>
                          {location.deleted? uiMsg("ER_DELETE"):uiMsg("ER_UPDATE") }
            </RaisedButton>
          </ToolbarGroup>
        </Toolbar>
      </PageLoading>
    );
  }

};



/** WEBPACK FOOTER **
 ** ./src/pages/EditRoomPage.jsx
 **/